export default __webpack_public_path__ + "static/media/fisher-funds-logo.590c1d59.svg";